import React from 'react'
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ProgressBar from './ProgressBar';

function Skills() {
    return (
        <SkillsStyled>
            <Title title={'My Skills'} span={'my skills'} />
                <InnerLayout>
                    <div className="skills">
                        <ProgressBar 
                            title={'HTML5'}
                            width={'70%'}
                            text={'70%'}
                        />
                        <ProgressBar 
                            title={'CSS3'}
                            width={'55%'}
                            text={'55%'}
                        />
                        <ProgressBar 
                            title={'JAVASCRIPT'}
                            width={'75%'}
                            text={'75%'}
                        />
                        <ProgressBar 
                            title={'JAVA'}
                            width={'70%'}
                            text={'70%'}
                        />
                        <ProgressBar 
                            title={'PYTHON'}
                            width={'85%'}
                            text={'85%'}
                        />
                        <ProgressBar 
                            title={'React JS'}
                            width={'60%'}
                            text={'60%'}
                        />
                        <ProgressBar 
                            title={'C'}
                            width={'90%'}
                            text={'90%'}
                        />
                        <ProgressBar 
                            title={'Node JS'}
                            width={'65%'}
                            text={'65%'}
                        />
                        <ProgressBar 
                            title={'Express JS'}
                            width={'60%'}
                            text={'60%'}
                        />
                        <ProgressBar 
                            title={'C++'}
                            width={'80%'}
                            text={'80%'}
                        />
                        <ProgressBar 
                            title={'SQL'}
                            width={'30%'}
                            text={'30%'}
                        />
                        <ProgressBar 
                            title={'MongoDB'}
                            width={'40%'}
                            text={'40%'}
                        />
                    </div>
                </InnerLayout>
        </SkillsStyled>
    )
}

const SkillsStyled = styled.section`
    .skills{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-row-gap: 2rem;
        grid-column-gap: 3rem;
        @media screen and (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
        }
    }
`;

export default Skills;
